// 引入message组件
import { Message } from 'element-ui'
// 引入router
import router from '@/router'

// API基础配置
const API_BASE_URL = 'https://www.huizhaowo.com/api'

// 请求工具函数
async function request (url, method = 'GET', data = null, headers = {}) {
  const options = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...headers
    }
  }

  // 添加token认证
  const token = localStorage.getItem('token')
  // console.log('token', token)
  if (token) {
    options.headers.Authorization = token
  }


  // 处理请求数据
  if (data && (method === 'POST' || method === 'PUT' || method === 'PATCH')) {
    options.body = JSON.stringify(data)
  }

  // 构建URL（处理GET请求的参数）
  let requestUrl = API_BASE_URL + url
  if (data && method === 'GET') {
    const params = new URLSearchParams()
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        params.append(key, data[key])
      }
    }
    requestUrl += '?' + params.toString()
  }

  try {
    const response = await fetch(requestUrl, options)
    if (!response.ok) {
      // 处理HTTP错误
      const errorData = await response.json().catch(() => ({}))
      // console.log('HTTP错误:', errorData)
      // 存储原始错误对象的code属性到Error对象中
      const error = new Error(errorData.msg || JSON.stringify(errorData))
      // 将服务器返回的code赋值给error对象 msg值也赋值
      if (errorData.code) {
        error.code = errorData.code
        error.msg = errorData.msg || error.message
      }
      throw error
    }

    // 处理成功响应
    // 优化后的成功响应处理
    const contentType = response.headers.get('content-type')
    if (contentType && contentType.includes('application/json')) {
      const data = await response.json()
      // code是0,200分别弹出提示
      if (data.code === 0) {
        Message.error(data.msg)
      } else if (data.code === 200) {
        Message.success(data.msg)
      } else if (data.code === 1404) {
        Message.error(data.msg)
        // 跳转到404页面
        router.push('/notFound')
      }

      return data
    } else {
      const data = await response.text()
      return data
    }
  } catch (error) {
    // console.log('请求错误:走这', error)
    // console.log('错误code:', error.code)

    // 统一错误处理
    if (error.code) {
      switch (error.code) {
        case 401:
          // 未授权，跳转到登录页
          localStorage.removeItem('token')
          localStorage.removeItem('userInfo')
          // 弹出提示
          Message.error(error.msg)
          // 使用router跳转到登录页
          router.push('/login')
          break
        case 403:
          Message.error('您没有权限访问此资源')
          break
        case 404:
          Message.error('请求的资源不存在')
        case 500:
          Message.error('服务器内部错误，请稍后再试')
          break
        default:
          Message.error(error.msg || '请求失败')
      }
    } else {
      Message.error('网络错误，请检查网络连接')
    }
    throw error
  }
}

// 导出API方法
export default {
  // 首页相关API
  index: {
    // 获取广告列表
    getAdList () {
      return request('/index/getAdList', 'GET')
    }
  },
  // 用户相关API
  user: {
    // 用户登录
    login (data) {
      return request('/user/login', 'POST', data)
    },
    // 登录验证码
    mobilelogin (data) {
      return request('/user/mobilelogin', 'POST', data)
    },
    // 微信登录
    wechatLogin (data) {
      return request('/user/wechatLogin', 'POST', data)
    },
    // 用户注册
    register (data) {
      return request('/user/register', 'POST', data)
    },
    // 修改密码
    changePassword (data) {
      return request('/user/changePassword', 'POST', data)
    },
    // 修改手机号
    changeMobile (data) {
      return request('/user/changeMobile', 'POST', data)
    },
    // 修改邮箱
    changeEmail (data) {
      return request('/user/changeEmail', 'POST', data)
    },
    // 获取用户信息
    getUserInfo (data) {
      return request('/user/info', 'POST', data)
    },
    // 用户登出
    logout () {
      return request('/user/logout', 'POST')
    },
    // 收藏夹
    getFavoriteList (data) {
      return request('/goods/getFavoriteList', 'POST', data)
    },
    // 删除收藏
    removeFavorite (data) {
      return request('/goods/removeFavorite', 'POST', data)
    },
    // 基础信息
    getBaseInfo (data) {
      return request('/user/getBaseInfo', 'POST', data)
    },
    // 认证分销伙伴
    approveSend (data) {
      return request('/distributor/approveSend', 'POST', data)
    },
    // 检查认证状态
    checkApprovalStatus () {
      return request('/distributor/checkApprovalStatus', 'POST')
    }
  },
  // 验证码相关API
  code: {
    // 发送验证码
    send (data) {
      return request('/sms/send', 'POST', data)
    },
    // 验证验证码
    verify (data) {
      return request('/sms/check', 'POST', data)
    }
  },
  // 设备相关API
  goods: {
    // 获取设备列表
    getList (data) {
      return request('/goods/getList', 'POST', data)
    },
    // 获取设备详情
    getDetail (data) {
      return request('/goods/getDetail', 'POST', data)
    },
    // 获取设备分类
    getCategoryList () {
      return request('/goods/getCategoryList', 'GET')
    },
    // 添加设备到购物车
    addToCart (data) {
      return request('/goods/addToCart', 'POST', data)
    },
    // 提交给后端购物车
    sendCart (data) {
      return request('/goods/sendCart', 'POST', data)
    },
    // 获取购物车内容
    getCart (data) {
      return request('/goods/getCart', 'POST', data)
    },
    // 添加设备到收藏列表
    addToFavorite (data) {
      return request('/goods/addToFavorite', 'POST', data)
    },

    // 获取地区选项
    getRegionOptions (data) {
      return request('/goods/getRegionOptions', 'POST', data)
    },
    // 收货地址
    getAddressList (data) {
      return request('/goods/getAddressList', 'POST', data)
    },
    // 添加收货地址
    addAddress (data) {
      return request('/goods/addAddress', 'POST', data)
    },
    // 删除收货地址
    removeAddress (data) {
      return request('/goods/removeAddress', 'POST', data)
    },
    // 设置默认收货地址
    setDefaultAddress (data) {
      return request('/goods/setDefaultAddress', 'POST', data)
    },
    // 编辑收货地址
    editAddress (data) {
      return request('/goods/editAddress', 'POST', data)
    },

  },
  // 订单相关API
  order: {
    // 提交快捷订单
    sendQuickOrder (data) {
      return request('/order/sendQuickOrder', 'POST', data)
    },
    // 获取快捷订单内容
    getQuickOrder (data) {
      return request('/order/getQuickOrder', 'POST', data)
    },
    // 创建订单
    createOrder (data) {
      return request('/order/createOrder', 'POST', data)
    },
    // 获取订单列表
    getOrderList (data) {
      return request('/order/getOrderList', 'POST', data)
    },
    // 获取订单详情
    getOrderDetail (data) {
      return request('/order/getOrderDetail', 'POST', data)
    },
    //获取预订单内容
    getPreOrder (data) {
      return request('/order/getPreOrder', 'POST', data)
    },
    // 获取预订单列表
    getPreOrderList (data) {
      return request('/order/getPreOrderList', 'POST', data)
    },
    // 确认提交预订单
    createPreOrder (data) {
      return request('/order/createPreOrder', 'POST', data)
    },
    // 保存预订单
    savePreOrder (data) {
      return request('/order/savePreOrder', 'POST', data)
    }
  },
  // 支付相关API
  payment: {
    // 发起支付
    initiatePayment (data) {
      return request('/payment/initiatePayment', 'POST', data)
    },
    // 验证支付结果
    verifyPayment (data) {
      return request('/payment/verifyPayment', 'POST', data)
    },
    // 支付宝轮询
    alipayPolling (data) {
      return request('/payment/alipayPolling', 'POST', data)
    },
    // 微信轮询
    wechatPolling (data) {
      return request('/payment/wechatPolling', 'POST', data)
    },
  },
  // 案例相关API
  caseshare: {
    // 获取案例列表
    getList (data) {
      return request('/caseshare/getList', 'POST', data)
    },
    // 获取案例详情
    getDetail (data) {
      return request('/caseshare/getDetail', 'POST', data)
    },
    // 获取案例分类
    getCategoryList () {
      return request('/caseshare/getCategoryList', 'GET')
    },
  },
  // 发票相关API
  invoice: {
    // 添加发票
    addInvoice (data) {
      return request('/invoice/addInvoice', 'POST', data)
    },
    // 获取发票列表
    getInvoiceList (data) {
      return request('/invoice/getInvoiceList', 'POST', data)
    },
    // 获取发票详情
    getInvoiceDetail (data) {
      return request('/invoice/getInvoiceDetail', 'POST', data)
    },
    // 更新发票状态
    updateInvoiceStatus (data) {
      return request('/invoice/updateInvoiceStatus', 'POST', data)
    },
    // 删除发票
    deleteInvoice (data) {
      return request('/invoice/deleteInvoice', 'POST', data)
    }
  },
  // 资讯相关API
  article: {
    // 获取资讯列表
    getList (data) {
      return request('/article/getList', 'POST', data)
    },
    // 获取资讯详情
    getDetail (data) {
      return request('/article/getDetail', 'POST', data)
    },
    // 获取资讯分类
    getCategoryList () {
      return request('/article/getCategoryList', 'GET')
    },
  },
  // 帮助相关API
  help: {
    // 获取帮助列表
    getList (data) {
      return request('/help/getList', 'POST', data)
    },
    // 获取帮助详情
    getDetail (data) {
      return request('/help/getDetail', 'POST', data)
    },
    // 获取帮助分类
    getCategoryList () {
      return request('/help/getCategoryList', 'GET')
    },
  },
}



// WEBPACK FOOTER //
// ./src/utils/api.js